<template>
	<div>
        <div class="flex mb-5">
            <div class="flex-1 mr-4 overflow-hidden">
                <media-gallery :media="site.building.media" :height="500"></media-gallery>
            </div>
            <div class="w-2/5 shadow-md">
                <map-component  
                    :latitude="site.building.latitude" 
                    :longitude="site.building.longitude"    
                    :zoom="6">
                </map-component>
            </div>
        </div>

		<div class="mt-10">
            <nav class="flex">
                <button
                    v-for="(tab, index) in enabledTabs" :key="index"
                    @click="activeTab = index"
                    type="button"
                    class="tab"
                    :class="{ 'tab-active': activeTab == index }"
                >
                    {{ tab.label }}
                </button>
            </nav>

            <div class="mt-5 bg-gray-50 border border-b-0">
		        <div class="p-6 flex justify-between" :class="{ 'hidden': activeTab != 'basic' }">
                    <basic-site-information :site-data="site"></basic-site-information>
		        </div>

		        <div :class="{ 'hidden': activeTab != 'building' }">
		            <edit-building-details :building-data="site.building"></edit-building-details>
		        </div>

		        <div class="px-8 py-6" :class="{ 'hidden': activeTab != 'leases' }">
		        	<leases :data="site"></leases>
		        </div>

		        <div class="px-8 py-6" :class="{ 'hidden': activeTab != 'utilization' }">
                    <site-utilization :site-data="site"></site-utilization>
		        </div>

		        <div class="hidden" :class="{ 'hidden': activeTab != 'contacts' }">
		        	contacts
		        </div>

		        <div class="mt-3 px-8 py-4" :class="{ 'hidden': activeTab != 'documents' }">
                    <documents
                        :document-data="site.documents"
                        :documentable-id="site.id"
                        documentable-type="App\Site"
                    ></documents>
		        </div>
			</div>
		</div>

        <notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    export default {
    	props: {
    		siteData: {
    			type: Object,
    			required: true
    		},

            showTab: {
                type: String,
                default: 'basic'
            }
    	},

    	data() {
    		return {
    			site: this.siteData,
                activeTab: this.showTab
    		}
    	},

    	computed: {
    	    enabledTabs() {
    	        // v-for used to be paired with v-if="tab.enabled"; Vue 2 runs
    	        // v-for first so the list was already filtered. Same result, and
    	        // it does not break when the directive priority reverses in Vue 3.
    	        const source = this.tabs;
    	        return Array.isArray(source)
    	            ? source.filter(entry => entry.enabled)
    	            : Object.fromEntries(Object.entries(source || {}).filter(([, entry]) => entry.enabled));
    	    },

            tabs() {
                return {
                	'basic': {
	                    label: 'Basic Information',
	                    enabled: true
	                },
	                'building': {
	                    label: 'Building',
	                    enabled: true
	                },
	                'leases': {
	                    label: 'Leases',
	                    enabled: this.site.lease_or_own == 'Leased'
	                },
	                'utilization': {
	                    label: 'Utilization',
	                    enabled: true
	                },
	                'contacts': {
	                    label: 'Contacts',
	                    enabled: false
	                },
	                'documents': {
	                    label: 'Documents',
	                    enabled: true
	                }
				}
            },
    	}
    }
</script>